// Claude: Unified AI chat history slice — shared between AI Chat page and floating drawer 23-03-2026
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ChatMessage = {
  id: number;
  text: string;
  sender: "ai" | "user";
  timestamp: Date;
};

interface AiChatState {
  buyerMessages: ChatMessage[];
  sellerMessages: ChatMessage[];
}

const initialState: AiChatState = {
  buyerMessages: [],
  sellerMessages: [],
};

const aiChatSlice = createSlice({
  name: "aiChat",
  initialState,
  reducers: {
    addBuyerMessage: (state, action: PayloadAction<ChatMessage>) => {
      state.buyerMessages.push(action.payload);
    },
    addSellerMessage: (state, action: PayloadAction<ChatMessage>) => {
      state.sellerMessages.push(action.payload);
    },
    setBuyerMessages: (state, action: PayloadAction<ChatMessage[]>) => {
      state.buyerMessages = action.payload;
    },
    setSellerMessages: (state, action: PayloadAction<ChatMessage[]>) => {
      state.sellerMessages = action.payload;
    },
    clearBuyerMessages: (state) => {
      state.buyerMessages = [];
    },
    clearSellerMessages: (state) => {
      state.sellerMessages = [];
    },
  },
});

export const {
  addBuyerMessage,
  addSellerMessage,
  setBuyerMessages,
  setSellerMessages,
  clearBuyerMessages,
  clearSellerMessages,
} = aiChatSlice.actions;

export const aiChatReducer = aiChatSlice.reducer;
